import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import OvRecordHeaderActions from './OvRecordHeaderActions';
import breakpoints from '../../../design-system/breakpoints';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvOrderHeaderActionsProps {
  isSubmitted: boolean;
  isDisabled: boolean;
  onEditStatus: () => void;
  onEditPaymentStatus: () => void;
  onSubmit: () => void;
}

const OvOrderHeaderActions: FC<OvOrderHeaderActionsProps> = ({
  isSubmitted,
  isDisabled,
  onEditStatus,
  onEditPaymentStatus,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <OvRecordHeaderActions>
      <QuietButton type="button" disabled={isDisabled} onClick={onEditStatus}>
        {t('common.actions.editStatus')}
      </QuietButton>
      <QuietButton
        type="button"
        disabled={isDisabled}
        onClick={onEditPaymentStatus}
      >
        {t('common.actions.editPaymentStatus')}
      </QuietButton>
      <SubmitGroup>
        <SubmitButton
          type="button"
          disabled={isSubmitted || isDisabled}
          onClick={onSubmit}
        >
          {t('common.actions.submitToDropshipper')}
        </SubmitButton>
        {isSubmitted && (
          <SubmitReason>{t('orders.details.alreadySubmitted')}</SubmitReason>
        )}
      </SubmitGroup>
    </OvRecordHeaderActions>
  );
};

export default OvOrderHeaderActions;

const QuietButton = styled.button`
  padding: 0.3125rem 0.5625rem;
  border: 1px solid transparent;
  background: transparent;
  color: ${Colours.OV_BASE};

  &:hover:not(:disabled) {
    background-color: ${Colours.OV_WHITE_HOVER};
  }

  &:disabled {
    color: ${Colours.OV_CHARCOAL};
  }
`;

const SubmitGroup = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1875rem;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: row;
    gap: 0.5rem;
  }
`;

const SubmitButton = styled.button`
  padding: 0.3125rem 0.75rem;
  border: 1px solid ${Colours.OV_BASE};
  background-color: ${Colours.OV_BASE};
  color: ${Colours.WHITE};

  &:hover:not(:disabled) {
    background-color: ${Colours.OV_BASE_HOVER};
  }

  &:disabled {
    border-color: ${Colours.OV_LIGHT_GRAY};
    background-color: ${Colours.OV_LIGHT_GRAY};
    color: ${Colours.OV_CHARCOAL};
  }
`;

const SubmitReason = styled.small`
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
